// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const fileStorageId = (z.number());
export const fileStorage = z.object({
    id: fileStorageId,
    path: z.string(),
    filename: z.string(),
    mime_type: z.string(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const fileStorageInitializer = z.object({
    id: fileStorageId.optional(),
    path: z.string(),
    filename: z.string(),
    mime_type: z.string(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const fileStorageMutator = z.object({
    id: fileStorageId.optional(),
    path: z.string().optional(),
    filename: z.string().optional(),
    mime_type: z.string().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=FileStorage.js.map